var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.6667C0 13.9303 0.477557 13.3333 1.06667 13.3333H14.9333C15.5225 13.3333 16 13.9303 16 14.6667C16 15.4031 15.5225 16 14.9333 16H8H1.06667C0.477557 16 0 15.4031 0 14.6667ZM0 1.33333C0 0.596947 0.477557 0 1.06667 0H14.9333C15.5225 0 16 0.596947 16 1.33333C16 2.06971 15.5225 2.66667 14.9333 2.66667H1.06667C0.477557 2.66667 0 2.06971 0 1.33333ZM0 8C0 7.26363 0.477557 6.66667 1.06667 6.66667H14.9333C15.5225 6.66667 16 7.26363 16 8C16 8.7364 15.5225 9.33333 14.9333 9.33333H1.06667C0.477557 9.33333 0 8.7364 0 8Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullView);
export default __webpack_public_path__ + "static/media/FullView.bedbe7d670d0246e4b231532044a2c48.svg";
export { ForwardRef as ReactComponent };